module.exports = __webpack_public_path__ + "img/Compartamos.e93b3989.svg";